import React, { useRef } from "react";
import "./LandingPage.css";
import megaphone from "../../images/megaphone.png";
import handIcon from "../../images/benefit-porcent.png";
import personIcon from "../../images/user-headset.png";

const WhyChooseUs = () => {
  const businessgrowthRef = useRef(null);

  return (
    <div className="bg-white py-20" id="businessgrowth" ref={businessgrowthRef}>
      <div className="anlook-benefits max-w-7xl mx-auto px-4">
        <h2 className="montserrat-font-1 anlook-benefits__title text-center text-2xl md:text-3xl font-bold text-[#0e4f4f] mb-12">
          Unlock New Opportunities
          <br />
          for Your Business with Anlook
        </h2>

        <div className="anlook-benefits__grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="anlook-benefits__card bg-white p-8 rounded-xl border border-gray-200">
            <div className="w-14 h-14 bg-green-100 rounded-full mb-6 flex items-center justify-center">
              <img src={megaphone} alt="megaphone" className="w-6 h-6" />
            </div>

            <h3 className="anlook-benefits__card-title text-xl font-semibold text-gray-800 mb-4">
              Leverage Anlook’s All in One Tools for Growth.
            </h3>

            <p className="montserrat-font-2 anlook-benefits__card-description text-gray-600 leading-relaxed text-sm">
              Attract quality leads with Anlook. Engage customers at every stage
              using smart notifications. Keep them informed with automated
              updates and track campaign results to understand performance.
            </p>
          </div>

          <div className="anlook-benefits__card bg-white p-8 rounded-xl border border-gray-200">
            <div className="w-14 h-14 bg-green-100 rounded-full mb-6 flex items-center justify-center">
              <img
                src={handIcon}
                alt="hand"
                className="w-7 h-7 object-contain block"
              />
            </div>

            <h3 className="montserrat-font-1 anlook-benefits__card-title text-xl font-semibold text-gray-800 mb-4">
              Boost Sales and Drive Conversions via WhatsApp
            </h3>

            <p className="montserrat-font-2 anlook-benefits__card-description text-gray-600 leading-relaxed text-sm">
              Turn chats into revenue with Anlook. Guide leads through your
              sales funnel, personalize offers, and encourage upsells. Accept
              payments directly on WhatsApp with secure integrated solutions.
            </p>
          </div>

          <div className="anlook-benefits__card bg-white p-8 rounded-xl border border-gray-200">
            <div className="w-14 h-14 bg-green-100 rounded-full mb-6 flex items-center justify-center">
              <img
                src={personIcon}
                alt="person"
                className="w-6 h-6 object-contain rad"
              />
            </div>

            <h3 className="montserrat-font-1 anlook-benefits__card-title text-lg font-semibold mb-4">
              Enhance Customer Support and Build Trust
            </h3>

            <p className="montserrat-font-2 anlook-benefits__card-description text-gray-600 leading-relaxed text-sm">
              Provide seamless support with Anlook’s 24×7 system. Use a single
              contact for all queries and automate responses for high-volume
              conversations. Monitor interactions to maintain excellent service
              standards.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WhyChooseUs;
